module.exports = __webpack_public_path__ + "img/hr-green-desert-bush-06.6368aa8c.png";